import { ExploreDevTokensTooltipClickArea } from './explore-dev-tokens-tooltip-click-area'
import { ExploreDevTokensTooltipCloseArea } from './explore-dev-tokens-tooltip-close-area'

export const ExploreDevTokensTooltip = {
  ClickArea: ExploreDevTokensTooltipClickArea,
  CloseArea: ExploreDevTokensTooltipCloseArea,
}
